export default __webpack_public_path__ + "static/media/pictogramSuperannuation48.e9da66a5.svg";